import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { classNames, format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import { bankCardMobx, payPlanMobx } from '@mobxStore'
import { IonContent, IonHeader, IonModal } from '@ionic/react'
import BankCardAuthModal from '../BankCardAuthModal'
import './index.scss'

interface IProps {
  payRechargeFlag?: boolean;
  bankCards?: IMutBankCardInfo[];
  selectedCard?: IMutBankCardInfo;
  resolve?: (data: IMutBankCardInfo) => void;
  reject?: () => void;
}

const SelectBankCardModal: FC<IProps> = ({ payRechargeFlag, bankCards, selectedCard, resolve, reject }) => {
  bankCards = bankCards || bankCardMobx?.memberBankCards

  const onSelect = (card: IMutBankCardInfo) => {
    console.log(card, '充值并支付··关于选择的银行卡')
    payPlanMobx.setBankCardInfo(card)
    resolve(card)
  }

  const onAuth = async () => {
    const card: IMutBankCardInfo = await modalLayer(BankCardAuthModal, { payRechargeFlag, multiUse: true }, 'bankCardAuthModal')
    onSelect(card)
  }

  return (
    <IonModal
      isOpen
      cssClass='select-bank-card-modal height620-modal'
      onDidDismiss={reject}
    >
      <IonHeader>
        <div className='select-bank-card-header'>
          <span>{i18n.t('pay.selectBankCard')}</span>
          <i className='iconfont icon-close' data-cypid='selectBankCardModalClose' onClick={reject} />
        </div>
      </IonHeader>
      <IonContent>
        <ul className='bank-card-list'>
          {bankCards?.map(x => (
            <li
              key={x.creditCardNo}
              className={classNames('bank-card-item', { selected: selectedCard && x.creditCardNo === selectedCard.creditCardNo })}
              data-cypid={`selectBankCardItem_${x?.creditCardNo}`}
              onClick={() => onSelect(x)}
            >
              <span className='card-number'>{format.maskCardNumber(x.creditCardNumber)}</span>
              {x.lastUsed && <span className='last-used'>{i18n.t('pay.lastUsed')}</span>}
              <i className={classNames('iconfont', selectedCard && x.creditCardNo === selectedCard.creditCardNo ? 'icon-checked' : 'icon-circle')} />
            </li>
          ))}
          <li className='bank-card-item' data-cypid='selectBankCardModalAuth' onClick={onAuth}>
            <span className='add-bank-card'>{i18n.t('pay.addBankCard')}</span>
            <i className='iconfont icon-chevron-right' />
          </li>
        </ul>
      </IonContent>
    </IonModal>
  )
}

export default observer(SelectBankCardModal)
